import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'chosen-options',
  template: `
    <div class="font-sm">
      <ng-content select="[unitSize]"></ng-content>
      <ng-content select="[variant]"></ng-content>
      <ng-content select="[addOns]"></ng-content>
    </div>
  `,
})
export class ChosenOptionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
